import styled from 'styled-components';
// import { rgba } from 'polished';
// import Typography from '../../atoms/Typography';
// import Avatar from '../../atoms/Avatar';

export const TopSection = styled.div`
  background-image: ${({ background }) => `url(${background})`};
  background-size: cover;
  background-position: center;
  height: 28.125rem;
  margin-bottom: -16.875rem;
  display: flex;
  justify-content: center;
  /* padding-right: 6rem; */
`;